import { EventDistributeService } from './../../ng3/event-distribute/event-distribute.service';
import { HttpImageLoaderService } from './../../image-store/http-image-loader/http-image-loader.service';
import { GrayImage2, GrayImage3 } from './../../image-slice-show/share/image';
import { Fovs } from './../../ng3/event-distribute/event-distribute.component';
import {
  CubeModel,
  SphereModel,
  CircleModel,
  Plane2Model,
  RingModel,
  OBJModel,
  VRMLModel,
  UserDefinedModel,
  ProfileModel,
  CrossLineModel,
  VolumeModel,
} from './../../ng3/model';
import { LineInputModel } from './../../cross-line/cross-line.component';
import { EntityDragEvent } from './../../ng3/controls/mouse/mouse-entity.service';
import { ImageStoreService } from './../../image-store/image-store.service';
import { ImageState } from './../../image-slice-show/share/model';
import {
  BoundingBox2,
  BoundingBox2FromCenterSize,
} from './../../ng3/share/boundingbox2';
import {
  Component,
  OnInit,
  Output,
  EventEmitter,
  OnDestroy,
  Input,
  AfterContentInit,
} from '@angular/core';
import { BehaviorSubject, noop, Observable } from 'rxjs';
import { Vector2, Vector3 } from 'three';
import { MultiCanvasService, ImageCanvasBind } from '../multi-canvas.service';
import { v4 as uuid } from 'uuid';
import { Ng3MosueWheelEvent } from '../../ng3/controls/mouse/mouse-canvas.service';
import { View } from '../../cross-line/cross-line.component';
import { CornerInfoService } from '../../corner-info/corner-info.service';
import { GroupedcrosslineService } from '../../cross-line/groupedcrossline.service';
import { map } from 'rxjs/operators';
import { ShowImageIntensity } from '../../image-slice-show/image3d/image3d.component';
import { EntityStoreService } from '../../entity-store/entity-store.service';
import { dummyGrayImage, dummyGrayImage3 } from '../../image-store/http-image-loader/image.debug.repository';

@Component({
  selector: 'app-multi-slice-canvas',
  templateUrl: './multi-slice-canvas.component.html',
  styleUrls: ['./multi-slice-canvas.component.css'],
})
export class MultiSliceCanvasComponent
  implements OnInit, OnDestroy, AfterContentInit {
  image3Subject = new BehaviorSubject<GrayImage3>(
    dummyGrayImage3(new Vector3(100, 100, 100), new Vector3(100, 100, 100)),
  );
  image3$ = this.image3Subject.asObservable();

  @Output() fovs = new EventEmitter<Fovs>();
  @Input() get image3(): GrayImage3 {
    return this.image3Subject.value;
  }
  set image3(i: GrayImage3) {
    this.image3Subject.next(i);
    this.loadService.image3Input = i;
  }
  image2 = dummyGrayImage(new Vector2(10, 10), new Vector2(10, 20));
  @Input()
  get tomo(): GrayImage2 {
    return this.image2;
  }
  set tomo(t: GrayImage2) {
    this.image2 = t;
  }
  @Input() tomoSize: Vector2 = new Vector2(500, 752);
  @Input() normalSize: Vector2 = new Vector2(500, 375);
  @Input() threeDSize: Vector2 = new Vector2(500, 375);

  @Input() tomoCameraSize: Vector2 = new Vector2(80, 60);
  @Input() normalCameraSize: Vector2 = new Vector2(80, 60);
  @Input() threeDCameraSize: Vector2 = new Vector2(400, 400);

  tomoCamera = new BoundingBox2FromCenterSize(
    new Vector2(0, 0),
    this.tomoCameraSize
  );
  normalCamera = new BoundingBox2FromCenterSize(
    new Vector2(0, 0),
    this.normalCameraSize
  );
  threeDCamera = new BoundingBox2FromCenterSize(
    new Vector2(0, 0),
    this.threeDCameraSize
  );
  id = uuid();
  image2$: Observable<GrayImage2>;
  canvasSelected = 'testCanvas';
  viewSelected: View = 'x';
  circleSubject = new BehaviorSubject<CircleModel>(
    new CircleModel(new Vector3(0, 0, 0), 10),
  );
  ringSubject = new BehaviorSubject<RingModel>(
    new RingModel(new Vector3(0, 0, 0), 5, 5.001),
  );
  circleMain = this.circleSubject.asObservable();
  ringMain = this.ringSubject.asObservable();
  planeSubject = new BehaviorSubject<BoundingBox2>(
    new BoundingBox2FromCenterSize(new Vector2(0, 0), new Vector2(20, 20)),
  );
  planeMain = this.planeSubject.asObservable();
  ringModelTemp = new RingModel(new Vector3(0, 0, 0), 3, 3.0001);
  shapePos: Vector2[] = [];
  shapeSubject = new BehaviorSubject<UserDefinedModel>(undefined);
  shapeMain = this.shapeSubject.asObservable();
  canvas$ = this.service.canvasOf(this.id);
  canvasTo: string;
  canvasVolume: string[];
  canvas3D: string;
  profile: number[] = [];
  profileSubject = new BehaviorSubject<ProfileModel>(undefined);
  profileMain = this.profileSubject.asObservable();
  profileTest = new ProfileModel([0, 50, 100, 50, 0]);
  imageInfo: ShowImageIntensity = {
    pos: new Vector3(0, 0, 0),
    index: new Vector3(1, 1, 1),
    intensity: 0.0,
  };
  cube = new CubeModel(
    new Vector3(50, 50, 50),
    new Vector3(0, 0, 0),
    new Vector3(0, 0, 0),
  );
  sphere = new SphereModel(new Vector3(10, 10, 10), 30);
  plane = new Plane2Model(
    new BoundingBox2FromCenterSize(new Vector2(0, 0), new Vector2(10, 10)),
    10,
    {
      r: new Uint8Array([255]),
      g: new Uint8Array([255]),
      b: new Uint8Array([255]),
      shape: new Vector2(1, 1),
    },
    new Vector3(0, 0, 0),
    true,
    0.5,
    true,
  );
  obj = new OBJModel(new Vector3(0, 0, 0));
  vrml = new VRMLModel(new Vector3(0, 0, 0));
  circle = new CircleModel(new Vector3(0, 0, 10), 10);
  ring = new RingModel(new Vector3(10, 0, 0), 30, 30);
  volume = new VolumeModel('red', 'bandpass', 0, 0.25, new GrayImage3(
    new Vector3(0, 0, 0),
    new Vector3(190, 256, 151),
    new Vector3(190, 256, 151),
    new Float32Array(190 * 256 * 151),
  ),);
  imageCanvasSubject = new BehaviorSubject<ImageCanvasBind[]>([]);
  imageCanvas$ = this.imageCanvasSubject.asObservable();
  lineSubject = new BehaviorSubject<LineInputModel>({
    id: 'testLine',
    position: new Vector3(10, 10, 10),
    view: 'x',
    crosslineLength: 2,
  });
  lineMain$ = this.lineSubject.asObservable();
  outPost: Vector3 = new Vector3(10, 10, 10);
  imgBoundingBox: BoundingBox2 = new BoundingBox2FromCenterSize(
    new Vector2(0, 0),
    new Vector2(60, 60), // image.size
  );
  cameraSize = new BoundingBox2FromCenterSize(
    new Vector2(0, 0),
    new Vector2(80, 60),
  );
  top_left_info: any[];
  top_right_info: any[];
  bottom_left_info: any[];
  bottom_right_info: any[];
  info = new Observable<string[]>();
  info2 = ['hhhhh', 'sssss'];
  position2 = new Vector2(100, 100);
  a = 10;
  crossline = new CrossLineModel(new Vector3(this.a, 10, 0), 'x');
  s = 10;
  @Output() selecteImages = new EventEmitter<ImageState[]>();

  eventHandler = this.distributionService.eventHandler;
  fovHandler = this.distributionService.fovHandler;
  constructor(
    public service: MultiCanvasService,
    public imageStoreService: ImageStoreService,
    private infoService: CornerInfoService,
    private crosslineService: GroupedcrosslineService,
    public entityStoreService: EntityStoreService,
    private loadService: HttpImageLoaderService,
    private distributionService: EventDistributeService,
  ) {
    console.log(this.s);
    // this.addCanvas();
    // this.addCanvas();
    // this.addCanvas();
    let i = 0;
    while (i < 5) {
      this.addCanvas();
      i++;
    }
    const fov1center = new Vector2(0, -20);
    const fov2center = new Vector2(0, 0);
    const fov3center = new Vector2(0, 20);
    this.canvas$.subscribe(e => {
      this.canvasTo = e[0];
      this.canvasVolume = [e[1], e[2], e[3]];
      this.canvas3D = e[4];
      this.entityStoreService.addFov(this.canvasTo, fov1center);
      this.entityStoreService.addFov(this.canvasTo, fov2center);
      this.entityStoreService.addFov(this.canvasTo, fov3center);
    });
    this.image3$
      .pipe(
        map(image => {
          this.updateToCanvas(this.canvasVolume[0], image);
          this.updateToCanvas(this.canvasVolume[1], image);
          this.updateToCanvas(this.canvasVolume[2], image);
        }),
      )
      .subscribe(noop, console.error);
    // this.resize();
    // this.image2$ = this.imageStoreService.grayIamge2$;
    // console.log(this.ring.center);
    // console.log(this.obj instanceof OBJModel);
  }

  updateToCanvas(canvas: string, image: GrayImage3) {
    this.service.mapOnCanvas(canvas, state => {
        this.imageStoreService.updateImage(state, image);
    });
  }
  resize() {
    const divTomo = document.getElementById('canvasTo');
    const divNormal = document.getElementById('canvas3D');
    console.log(divTomo.onresize);
    // this.tomoSize = new Vector2(
    //   divTomo.offsetWidth - 5,
    //   divTomo.offsetHeight - 5,
    // );
    // this.normalSize = new Vector2(
    //   divNormal.offsetWidth - 5,
    //   divNormal.offsetHeight - 5,
    // );
  }
  select(canvas: string, index) {
    this.canvasSelected = canvas;
    this.viewOf$(canvas)
      .pipe(map(b => (this.viewSelected = b)))
      .subscribe(noop, err => console.error(err));
    this.service.select(canvas);
  }

  addCanvas() {
    this.service.addCanvasTo(this.id);
  }

  imageOf$(canvas: string) {
    return this.service.imageOf$(canvas);
  }

  viewOf$(canvas: string) {
    return this.service.viewOf$(canvas);
  }

  scrollImageOfCanvas(canvas: string, e: Ng3MosueWheelEvent) {
    this.service.mapOnCanvas(canvas, image =>
      this.imageStoreService.addIndex(image, e.delta / Math.abs(e.delta)),
    );
    e.event.preventDefault();
  }

  dragWidthOfImage(canvas: string, d: EntityDragEvent) {
    this.service.mapOnCanvas(canvas, image =>
      this.imageStoreService.addWidthByStep(
        image,
        d.current.x - d.origin.x === 0
          ? 0
          : Math.abs(d.current.x - d.origin.x) / (d.current.x - d.origin.x),
      ),
    );
  }

  entitiesOfCanvas(canvas: string) {
    return this.entityStoreService.entitiesOfCanvas(canvas);
  }

  dragRing(d: EntityDragEvent, canvasId: string) {
    this.position2 = d.origin;
    const circleRadius = Math.sqrt(
      Math.pow(d.current.x - d.origin.x, 2) +
        Math.pow(d.current.y - d.origin.y, 2),
    );
    this.entityStoreService.updateRingEntity({
      canvasId: canvasId,
      model: new RingModel(
        new Vector3(d.origin.x, d.origin.y, 0),
        circleRadius,
        circleRadius + 0.001,
      ),
    });
  }
  getPointPos(d: Event) {
    this.shapePos.push(
      new Vector2((d as MouseEvent).clientX, (d as MouseEvent).clientY),
    );
    // this.shapeSubject.next([...this.shapeSubject.value, new Vector2((d as MouseEvent).clientX, (d as MouseEvent).clientY)]);
  }

  getPointPos2() {
    if (this.shapePos.length > 2) {
      this.shapePos.pop();
      this.shapePos.pop();
      this.shapeSubject.next(new UserDefinedModel(this.shapePos));
    }
    this.shapePos = [];
    this.profileSubject.next(
      new ProfileModel([
        Math.random() * 20,
        Math.random() * 30,
        Math.random() * 50,
      ]),
    );
  }
  dragPlane(d: EntityDragEvent) {
    this.planeSubject.next(
      new BoundingBox2FromCenterSize(
        new Vector2(
          (d.current.x + d.origin.x) / 2,
          (d.current.y + d.origin.y) / 2,
        ),
        new Vector2(
          Math.abs(d.current.x - d.origin.x),
          Math.abs(d.current.y - d.origin.y),
        ),
      ),
    );
  }
  dragLine(canvas: string, d: EntityDragEvent) {
    let temp = new Vector3(0, 0, 0);
    this.crosslineService.updatePosition(
      'testLine',
      new Vector2(d.current.x, d.current.y),
      this.viewSelected,
    );
    this.crosslineService.position3$('testLine').subscribe(b => (temp = b));
    this.lineSubject.next({
      id: 'testLine',
      position: temp,
      view: this.viewSelected,
      crosslineLength: 2,
    });
    this.service.mapOnCanvas(canvas, image =>
      this.crosslineService.crosslineMain$
        .pipe(map(x => this.getImageInfo(image, this.imgBoundingBox, x)))
        .subscribe(noop),
    );
  }

  dragCrossline(d: EntityDragEvent, canvasId: string) {
    this.entityStoreService.updateCrosslineEntity({
      canvasId: canvasId,
      model: new CrossLineModel(new Vector3(d.current.x, d.current.y, 0), 'z'),
    });
    // this.a = this.a + 2;
    // this.crossline = new CrossLineModel(new Vector3(this.a, 10, 0), 'x');
  }

  getImageInfo(image: ImageState, box: BoundingBox2, cross: LineInputModel[]) {
    const indexT = new Vector3(
      Math.ceil(
        (Math.ceil(cross[cross.length - 1].position.x + box.size.x / 2) /
          box.size.x) *
          image.image.meta.size.x,
      ),
      Math.ceil(
        (Math.ceil(cross[cross.length - 1].position.y + box.size.x / 2) /
          box.size.x) *
          image.image.meta.size.y,
      ),
      Math.ceil(
        (Math.ceil(cross[cross.length - 1].position.z + box.size.x / 2) /
          box.size.x) *
          image.image.meta.size.z,
      ),
    );
    switch (image.slicer.direction) {
      case 'x':
        this.imageStoreService.updateIndex(image, indexT.x);
        break;
      case 'y':
        this.imageStoreService.updateIndex(image, indexT.y);
        break;
      case 'z':
        this.imageStoreService.updateIndex(image, indexT.z);
        break;
    }
    this.imageInfo = {
      pos: cross[cross.length - 1].position,
      index: indexT,
      intensity: image.image.pixel3(indexT.x, indexT.y, indexT.z),
    };
  }
  // addCrossLine() {
  //   this.crosslineAdd = !this.crosslineAdd;
  //   let posTemp = new Vector3(0, 0, 0);
  //   this.multicrosslineService.loadCrosslineToCanvas(this.canvasSelected, 10);
  //   this.crosslineService.updatePosition(
  //     'testLine',
  //     new Vector2(0, 0),
  //     this.viewSelected,
  //   );
  //   this.crosslineService.position3$('testLine').subscribe(b => (posTemp = b));
  //   this.lineSubject.next({
  //     id: 'testLine',
  //     position: posTemp,
  //     view: this.viewSelected,
  //     crosslineLength: 2,
  //   });
  //   this.service.addCrossLine();
  // }

  setOutPos(e: Vector3) {
    this.outPost = e;
  }

  setImageInfo(d: ShowImageIntensity) {
    this.imageInfo = d;
  }
  isSelected$(canvas: string) {
    return this.service.isSelected$(canvas);
  }

  isWithCanvas(c: string) {
    return this.service.isWithCanvas$(c);
  }

  dragLevelOfImage(canvas: string, d: EntityDragEvent) {
    this.service.mapOnCanvas(canvas, image =>
      this.imageStoreService.addLevelByStep(
        image,
        d.current.y - d.origin.y === 0
          ? 0
          : Math.abs(d.current.y - d.origin.y) / (d.current.y - d.origin.y),
      ),
    );
  }

  dragWidthLevelOfImage(canvas: string, d: EntityDragEvent) {
    this.service.mapOnCanvas(canvas, image =>
      this.imageStoreService.addWidthLevelFilterByStep(
        image,
        d.current.x - d.origin.x === 0
          ? 0
          : Math.abs(d.current.x - d.origin.x) / (d.current.x - d.origin.x),
        d.current.y - d.origin.y === 0
          ? 0
          : Math.abs(d.current.y - d.origin.y) / (d.current.y - d.origin.y),
      ),
    );
  }
  displayFovs(value: Fovs) {
    // console.log(value);
    this.fovs.emit(value);
  }
  ngOnInit() {
    this.top_left_info = this.infoService.top_left_info();
    this.top_right_info = this.infoService.top_right_info();
    this.bottom_left_info = this.infoService.bottom_left_info();
    this.bottom_right_info = this.infoService.bottom_right_info();
  }
  ngAfterContentInit(): void {
    // this.resize();
  }
  ngOnDestroy(): void {
    this.ringSubject.complete();
    this.circleSubject.complete();
  }
}
